// extracted by mini-css-extract-plugin
export default {"cartContainer":"CO","summarycontent":"EO","offset":"FO","leaf":"GO","summaryclosed":"HO","summaryheader":"IO","summaryitems":"JO","summaryprice":"KO","buttonopen":"LO","buttondown":"MO","summaryfixed":"NO","usdnotification":"OO","renew":"PO","promowrapper":"QO","ordersummarywrap":"RO","simplewrap":"SO"};
    if(module.hot) {
      // 1738064242385
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  